import React from 'react';

import {
  useLoadPartnerUser,
  useCreatePartnerUser,
  useUpdatePartnerUser,
} from '../../data';
import PartnerUsersForm from './PartnerUsersForm';

export const PartnerUserFormCreate = ({
  title = 'Add Partner User',
  subTitle,
  initialValues,
  loading,
  open,
  onSubmit,
  onClose,
  onExited,
  enableReinitialize,
  active,
}) => {
  const [createUser, { isLoading: isCreating }] = useCreatePartnerUser();
  const handleSubmit = async (values) => {
    await createUser(values);
    onSubmit();
  };

  return (
    <PartnerUsersForm
      title={title}
      subTitle={subTitle}
      initialValues={initialValues}
      loading={loading || isCreating}
      open={open}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      enableReinitialize={enableReinitialize}
      active={active}
    />
  );
};

export const PartnerUserFormEdit = ({ id, onClose, ...props }) => {
  const [updateUser, { isLoading: isUpdating }] = useUpdatePartnerUser();
  const { data, isLoading } = useLoadPartnerUser(id);

  const handleSubmit = async (values) => {
    await updateUser(values);
    onClose();
  };

  return (
    <PartnerUsersForm
      {...props}
      title={'Edit Partner User'}
      subTitle={data?.name}
      entityId={id}
      initialValues={data}
      loading={isLoading || isUpdating}
      enableReinitialize={true}
      active={!!data}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
};

export const PartnerUserFormDuplicate = ({
  id,
  open,
  onClose,
  onExited,
  onSubmit,
}) => {
  const { data, isLoading } = useLoadPartnerUser(id);

  return (
    <PartnerUserFormCreate
      title={'Duplicate User'}
      subTitle={data?.name}
      initialValues={{
        businessPartnerId: data?.businessPartnerId,
        permissions: data?.permissions,
      }}
      open={open}
      onClose={onClose}
      onExited={onExited}
      onSubmit={onSubmit}
      loading={isLoading}
      enableReinitialize={true}
      active={data}
    />
  );
};
